import { CapitalizeModule } from './../../pipes/capitalize/capitalize.module'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { TabsModule } from 'ngx-bootstrap/tabs'

import { PaymentInfoForm } from './payment-info-form.component'

@NgModule({
  imports: [
    CapitalizeModule,
    CommonModule,
    FormsModule,
    TabsModule
  ],
  declarations: [
    PaymentInfoForm
  ],
  exports: [
    PaymentInfoForm
  ]
})
export class PaymentInfoFormModule {}
